import { render, staticRenderFns } from "./retail_order_list.vue?vue&type=template&id=28763534&scoped=true"
import script from "./retail_order_list.vue?vue&type=script&lang=js"
export * from "./retail_order_list.vue?vue&type=script&lang=js"
import style0 from "./retail_order_list.vue?vue&type=style&index=0&id=28763534&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28763534",
  null
  
)

export default component.exports